type RuntimeConfig = {
  apiUrl: string
  authCookieDomain?: string
  yandexMapsApiKey?: string
}

const raw = window.__CONFIG__ ?? {}

if (!raw.apiUrl) {
  throw new Error("config.js: apiUrl is not set")
}

// envsubst writes an unset variable as "".
const optional = (value?: string) => value || undefined

export const runtimeConfig: RuntimeConfig = {
  apiUrl: raw.apiUrl,
  authCookieDomain: optional(raw.authCookieDomain),
  yandexMapsApiKey: optional(raw.yandexMapsApiKey),
}
